/**
 * Scroll Focus Polyfill - Auto-execute version
 *
 * This is the default entry point that automatically applies the polyfill
 * when the script is loaded.
 */

import { applyPolyfill } from './core.js';

// Check for data attributes on the script tag for configuration
function getConfigFromScriptTag() {
  let scriptTag = document.currentScript;

  // Fallback: if currentScript is null, search for the scroll-focus-polyfill script
  // (this happens with dynamically injected scripts from unpkg, CDNs, etc.)
  if (!scriptTag) {
    const scripts = document.scripts;
    for (let i = 0; i < scripts.length; i++) {
      const script = scripts[i];
      if (script.src && script.src.includes('scroll-focus-polyfill')) {
        scriptTag = script;
        break;
      }
    }
  }

  if (!scriptTag) return {};

  const config = {};

  if (scriptTag.hasAttribute('data-debug')) {
    config.debug = scriptTag.getAttribute('data-debug') !== 'false';
  }

  if (scriptTag.hasAttribute('data-force')) {
    config.force = scriptTag.getAttribute('data-force') !== 'false';
  }

  if (scriptTag.hasAttribute('data-selectors')) {
    const selectors = scriptTag.getAttribute('data-selectors');
    config.selectors = selectors.split(',').map((s) => s.trim());
  }

  return config;
}

// Auto-run when the script is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    const config = getConfigFromScriptTag();
    applyPolyfill(config);
  });
} else {
  const config = getConfigFromScriptTag();
  applyPolyfill(config);
}

// Also export for manual usage if needed
export { applyPolyfill };
